import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import i18n from "i18next";
import { withTranslation } from "react-i18next";

import "./styles/usersStyle.css";
import "./styles/deviseStyle.css";
import "../../assets/Common.css";

import screebotShow from "./assets/screebot_show.svg";
import screebotHide from "./assets/screebot_hide.svg";
import logo2 from "../../assets/logo.svg";

class SignIn extends Component {
  state = {
    email: "",
    password: "",
    buttonDisabled: true,
    error: "",
    showPassword: false,
    confirmationToken: "",
  };

  constructor(props) {
    super(props);

    const queryParameters = new URLSearchParams(window.location.search);
    const affilae = queryParameters.get("ae") || localStorage.getItem("ae");

    this.state = {
      email: "",
      password: "",
      buttonDisabled: true,
      error: "",
      showPassword: false,
      confirmationToken: queryParameters.get("confirmation_token"),
    };

    if (affilae) {
      localStorage.setItem("ae", affilae);
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    // function runDelayedFunction(times) {
    //   if (times > 0) {
    //     setTimeout(() => {
    //       this.handleChange({
    //         target: {
    //           value: document.getElementById("email").value,
    //           name: "email"
    //         }
    //       });
    //       this.handleChange({
    //         target: {
    //           value: document.getElementById("password").value,
    //           name: "password"
    //         }
    //       });
    //       document.getElementById("email").focus();

    //       this.checkAutofilled()
    //       this.checkInputs()
    //       document.getElementById("email").focus();
    //       runDelayedFunction.call(this, times - 1);
    //     }, 300);
    //   }
    // }
    // runDelayedFunction.call(this, 15);
  }

  // checkAutofilled = () => {
  //   const email = !!document.getElementById('email')?.matches('*:-webkit-autofill')
  //   console.log(email)
  //   if(email){
  //     console.log(document.getElementById('email').innerHTML)
  //     this.setState({ email: document.getElementById('email').value})
  //     console.log(this.state.email)
  //   }

  //   const password = !!document.getElementById('password')?.matches('*:-webkit-autofill')
  //   console.log(password)
  //   if(password){
  //      console.log(document.getElementById('password').value)
  //      this.setState({ password: document.getElementById('password').value})
  //   }
  // }

  validate = () => {
    (this.state.email.length > 1) & (this.state.password.length > 1)
      ? this.checkInputs()
      : this.setState({ buttonDisabled: true });
  };

  showPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  checkInputs = () => {
    let checkEmail = this.checkEmailFormat();
    this.setState({ buttonDisabled: checkEmail });
  };

  checkEmailFormat = () => {
    if (this.state.email !== undefined) {
      let re = /^[\w\-.]+@([\w-]+\.)+[\w-]{1,5}$/g;
      if (re.test(this.state.email)) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  handleChange = (e) => {
    let newValue = e.target.value;
    let key = e.target.name;
    this.setState({
      [key]: newValue,
    });
    this.validate();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.validate();
    let data = {
      user: { email: this.state.email, password: this.state.password },
    };
    axios
      .post(process.env.REACT_APP_URL_API + "/login", data, {
        validateStatus: function (status) {
          return status >= 200 && status < 500; // Catch errors from 200 to 499
        },
      })
      .then((response) => {
        if (
          response.status === 401 ||
          response.status === 404 ||
          response.status === 422
        ) {
          this.setState({ error: i18n.t("sign.in.wrong_password_email") });
        }
        if (response.status === 405) {
          this.setState({ error: i18n.t("sign.in.account_not_confirmed") });
        }
        if (response.status === 204) {
          const currentTime = new Date().getTime();
          const expirationTime = currentTime + 24 * 60 * 60 * 1000;
          localStorage.setItem("tokenExpiration", expirationTime);
          localStorage.setItem("token", response.headers["authorization"]);
          window.location = process.env.REACT_APP_URL;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  render() {
    return (
      <div className="card">
        <div className="global-layout">
          <div id="sign_in_form" className="right-part">
            <div className="right-layout flex flex-col gap-y-1">
              <div className="flex flex-col gap-y-8 pb-6">
                <div className="mx-auto">
                  <img
                    src={logo2}
                    alt="Screebot logo"
                    className="right-layout-logo"
                  />
                </div>
                <h1 className="text-secondary text-center">
                  {i18n.t("sign.in.sign_in")}
                </h1>
              </div>
              {this.state.confirmationToken === "sended" && (
                <div className="sign_up_token">
                  <div>{i18n.t("sign.in.token_sended")}</div>
                </div>
              )}
              {this.state.error && <div className="">{this.state.error}</div>}
              <form onSubmit={this.handleSubmit.bind(this)}>
                <div className="flex flex-col gap-y-6">
                  <div className="flex flex-col gap-y-4 ">
                    <div className="w-full">
                      <input
                        autoFocus
                        id="email"
                        type="email"
                        autoComplete="email"
                        name="email"
                        className="w-full"
                        placeholder={i18n.t("sign.in.email_placeholder")}
                        onChange={this.handleChange}
                        value={this.state.email}
                      />
                    </div>
                    {/* <div className="field pwd-container  input rounded  border flex-row"> */}
                    <div className="relative w-full">
                      <input
                        id="password"
                        className="relative w-full"
                        type={this.state.showPassword ? "text" : "password"}
                        autoComplete="current-password"
                        name="password"
                        placeholder={i18n.t("sign.in.password_placeholder")}
                        onChange={this.handleChange}
                        value={this.state.password}
                      />
                      <span className="show-password">
                        {this.state.showPassword ? (
                          <img
                            src={screebotShow}
                            alt="show password"
                            onClick={() => this.showPassword()}
                          />
                        ) : (
                          <img
                            src={screebotHide}
                            alt="hide password"
                            onClick={() => this.showPassword()}
                          />
                        )}
                      </span>
                    </div>
                  </div>
                  {/* </div> */}
                  <div className="actions mx-auto">
                    {/* disabled={this.state.buttonDisabled}  */}
                    <button type="submit" className="secondary-btn">
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.0777 9.94397C12.333 9.69875 12.333 9.30125 12.0777 9.05603L9.89821 6.96298C9.64286 6.71777 9.22893 6.71777 8.97358 6.96298C8.71824 7.20819 8.71824 7.60576 8.97358 7.85095L10.0368 8.87209H3.76923C3.40812 8.87209 3.11539 9.15323 3.11539 9.5C3.11539 9.84677 3.40812 10.1279 3.76923 10.1279H10.0368L8.97358 11.1491C8.71824 11.3943 8.71824 11.7918 8.97358 12.037C9.22893 12.2822 9.64286 12.2822 9.89821 12.037L12.0777 9.94397Z"
                          fill="white"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10.6957 0.5H11.6632C12.8555 0.499984 13.8165 0.499967 14.5723 0.597552C15.357 0.698871 16.0177 0.915616 16.5425 1.41955C17.0672 1.92348 17.2929 2.55798 17.3984 3.31156C17.5 4.03739 17.5 4.96027 17.5 6.10523V12.8948C17.5 14.0398 17.5 14.9626 17.3984 15.6885C17.2929 16.4421 17.0672 17.0765 16.5425 17.5805C16.0177 18.0844 15.357 18.3012 14.5723 18.4025C13.8165 18.5 12.8555 18.5 11.6632 18.5H10.6957C9.50346 18.5 8.54248 18.5 7.78672 18.4025C7.00197 18.3012 6.34126 18.0844 5.81651 17.5805C5.46797 17.2457 5.25135 16.8534 5.11426 16.4068C4.28495 16.4058 3.59401 16.397 3.03421 16.3248C2.3682 16.2388 1.79078 16.0527 1.32987 15.61C0.868953 15.1674 0.67517 14.6129 0.585628 13.9733C0.499966 13.3615 0.499983 12.5864 0.5 11.638V7.36203C0.499983 6.41362 0.499966 5.63857 0.585628 5.0267C0.67517 4.38711 0.868953 3.8326 1.32987 3.38996C1.79078 2.94734 2.3682 2.76124 3.03421 2.67525C3.59401 2.60298 4.28495 2.59421 5.11426 2.59317C5.25135 2.1466 5.46797 1.75427 5.81651 1.41955C6.34126 0.915616 7.00197 0.698871 7.78672 0.597552C8.54248 0.499967 9.50346 0.499984 10.6957 0.5ZM4.85897 12.8948C4.85897 13.7738 4.85895 14.5218 4.90493 15.1504C4.17748 15.1477 3.63669 15.1354 3.20846 15.0802C2.68746 15.0129 2.43199 14.8925 2.25455 14.722C2.0771 14.5516 1.9517 14.3063 1.88166 13.8059C1.80909 13.2876 1.80769 12.5974 1.80769 11.593V7.40698C1.80769 6.40257 1.80909 5.71242 1.88166 5.19403C1.9517 4.6937 2.0771 4.44836 2.25455 4.27796C2.43199 4.10755 2.68746 3.98714 3.20846 3.91987C3.63669 3.86458 4.17748 3.85231 4.90493 3.8496C4.85895 4.47814 4.85897 5.22623 4.85897 6.10522V6.15116C4.85897 6.49795 5.15171 6.77907 5.51282 6.77907C5.87394 6.77907 6.16667 6.49795 6.16667 6.15116C6.16667 4.94942 6.16806 4.11128 6.25659 3.47889C6.3426 2.86457 6.49991 2.53925 6.74119 2.30754C6.98247 2.07584 7.32119 1.92476 7.96091 1.84217C8.61946 1.75715 9.49222 1.75581 10.7436 1.75581H11.6154C12.8668 1.75581 13.7395 1.75715 14.3981 1.84217C15.0378 1.92476 15.3765 2.07584 15.6178 2.30754C15.8591 2.53925 16.0164 2.86457 16.1024 3.47889C16.1909 4.11128 16.1923 4.94942 16.1923 6.15116V12.8488C16.1923 14.0506 16.1909 14.8887 16.1024 15.5211C16.0164 16.1355 15.8591 16.4607 15.6178 16.6925C15.3765 16.9242 15.0378 17.0752 14.3981 17.1579C13.7395 17.2428 12.8668 17.2442 11.6154 17.2442H10.7436C9.49222 17.2442 8.61946 17.2428 7.96091 17.1579C7.32119 17.0752 6.98247 16.9242 6.74119 16.6925C6.49991 16.4607 6.3426 16.1355 6.25659 15.5211C6.16806 14.8887 6.16667 14.0506 6.16667 12.8488C6.16667 12.5021 5.87394 12.2209 5.51282 12.2209C5.15171 12.2209 4.85897 12.5021 4.85897 12.8488V12.8948Z"
                          fill="white"
                        />
                      </svg>
                      {i18n.t("sign.in.sign_in_2")}
                    </button>
                  </div>
                  <div className="flex flex-col gap-y-2">
                    <div className="text-center">
                      <Link
                        to="/users/reset_password"
                        className="cursor-pointer font-normal text-secondary text-base"
                      >
                        {i18n.t("sign.in.forgot_password")}
                      </Link>
                    </div>
                    <div className="text-center">
                      <Link
                        to="/users/sign_up"
                        className="cursor-pointer font-normal text-screebot-blue text-base"
                      >
                        {i18n.t("sign.in.create_account")}
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(SignIn);
